import React, { FC } from "react"
import { Text } from "dash-styled"
import { APIAppInstanceModel } from "../../../../../../Models/API/AppInstanceModel"
import { CustomerAppInstanceCard } from "./CustomerAppInstanceCard"

interface CustomerAppGroupProps {
    groupName: string
    apps: APIAppInstanceModel[]
    onOpenProject?: (appID: string) => void
}

export const CustomerAppGroup: FC<CustomerAppGroupProps> = ({
    groupName,
    apps,
    onOpenProject
}) => {
    const renderApp = (app: APIAppInstanceModel) => (
        <CustomerAppInstanceCard
            key={app.uuid}
            app={app}
            onOpenProject={onOpenProject}
        />
    )
    return (
        <div className="grid grid-cols-3">
            <Text size="md" weight="semibold" className="m-0">
                Project {groupName.toLowerCase()}:
            </Text>

            <ol className="col-span-2">{apps.map(renderApp)}</ol>
        </div>
    )
}
